import BaseModel from "../model/base_model";
import PaginatedResult from "./result/paginated_result";
import _ from "underscore";

export default class BaseRepository {

    itemUrl = '';
    listUrl = '';
    modelClass = BaseModel;
    paginator = null;

    items = null;

    /**
     * Constructor
     */
    constructor(paginator = null) {
        this.paginator = paginator;
        this.items = [];
    }

    /**
     * Save model
     *
     * @param {BaseModel} model
     */
    save(model) {
        if (this.itemUrl === '') {
            throw 'Please set itemUrl in repository';
        }
        let url = this.itemUrl;
        if (!model.isNew()) {
            url += '/' + model.id;
        }

        return this._save(url, model.isNew() ? 'POST' : 'PUT', model);
    }

    _save(url, method, model, data = null) {
        return new Promise((resolve, reject) => {
            if (data === null) {
                data = model ? JSON.stringify(model) : null;
            }
            $.ajax(url, {
                data: data,
                contentType: 'application/json',
                type: method,
                success: (data) => {
                    if (!model) {
                        model = new this.modelClass();
                    }

                    model.fromJSON(data);
                    resolve(model);
                },
                error: (xhr) => {
                    reject((xhr.responseJSON || {}));
                }
            });
        });
    }

    /**
     * Fetch model from server by id
     *
     * @param id
     * @returns {Promise<T extends BaseModel>}
     */
    fetchById(id) {
        if (this.itemUrl === '') {
            throw 'Please set itemUrl in repository';
        }
        return this._fetch(this.itemUrl + (id ? '/' + id : ''));
    }

    /**
     * Fetch model from server by url
     *
     * @param url
     * @param data
     * @returns {Promise<T extends BaseModel>}
     */
    _fetch(url, data = {}) {
        return new Promise((resolve, reject) => {
            $.getJSON(url, data, (result) => {
                let model = new this.modelClass();
                model.fromJSON(result);
                resolve(model);
            }).fail((xhr) => {
                reject((xhr.responseJSON || {}));
            });
        });
    }

    /**
     * Delete model by id
     *
     * @param id
     * @return {Promise<unknown>}
     */
    delete(id) {
        if (this.itemUrl === '') {
            throw 'Please set itemUrl in repository';
        }
        return new Promise((resolve, reject) => {
            $.ajax(this.itemUrl + '/' + id, {
                contentType: 'application/json',
                type: 'DELETE',
                success: (data) => {
                    resolve();
                },
                error: (xhr) => {
                    reject((xhr.responseJSON || {}));
                }
            });
        });
    }

    /**
     * Fetch paginated list
     *
     * @returns {Promise<PaginatedResult>}
     */
    fetchPaginatedList() {
        return new Promise((resolve, reject) => {
            $.getJSON(this.listUrl, this.paginator ? this.paginator.toJSON() : null, (result) => {
                let paginatedResult = new PaginatedResult(result, this.modelClass);
                if (this.paginator) {
                    this.paginator.updatePagesData(paginatedResult);
                }

                this.items = paginatedResult.items;

                resolve(paginatedResult);
            }).fail((xhr) => {
                reject((xhr.responseJSON || {}));
            });
        });
    }

    /**
     * Fetch not paginated list
     *
     * @return {Promise<Array>}
     */
    fetchList() {
        return new Promise((resolve, reject) => {
            $.getJSON(this.listUrl, null, (result) => {
                this.items = [];
                result.map((item, key) => {
                    let row = new this.modelClass();
                    row.fromJSON(item);

                    this.items.push(row);
                });

                resolve(this.items);
            }).fail((xhr) => {
                reject((xhr.responseJSON || {}));
            });
        });
    }

    /**
     * Return model by id
     */
    get(id) {
        return _.findWhere(this.items, {id: id});
    }

    /**
     * Find first model by query
     */
    find(where) {
        return _.findWhere(this.items, where);
    }

}